import ListFilters from "@/common/components/ListFilters";
import { Option } from "@/common/types/option";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";

interface DashboardFilterBadgeProps extends DashboardFilterProps {
  filterKey: DashboardFilters;
  options: Option[];
  setSearch?: (value: string) => void;
}

const DashboardFilterBadge = ({
  filterKey,
  options,
  filters,
  setFilters,
  setSearch,
}: DashboardFilterBadgeProps) => {
  return (
    <ListFilters
      filters={[
        {
          className: 'bg-blue-200/20 rounded-xl shadow-none max-w-[200px] text-nowrap',
          placeholder: dashboardFilters[filterKey],
          options: [{ label: 'Todas', value: '' }, ...options],
          value: filters[filterKey],
          onChange: (e: any) => setFilters((prev) => ({ ...prev, [filterKey]: e?.value ? e : null })),
          onInputChange: setSearch,
        }
      ]}
    />
  );
}

export default DashboardFilterBadge;
